<template>
  <div>
    <div v-if="isCategoriesPending" class="loader">
      <b-spinner label="Loading..." variant="primary"/>
    </div>

    <div
      :id="patchId" 
      ref="patchContainer">
    </div>
  </div>
</template>

<script>
import * as SVG from 'svg.js/dist/svg';
import svgApi from '@/api/svgApi';
import SvgMixin from '@/components/canvas/SvgMixin';
import { uniqueId } from '@/common/utils';
import flattenDeep from 'lodash/flattenDeep';

export default {
  name: 'PatchForSideBar',

  mixins: [SvgMixin],

  props: {
    canvasUrl: String,
    tagsMap: Object
  },

  data () {
    return {
      patchId: uniqueId('svg-'),
      svgText: null,
      isCategoriesPending: true,

      canvas: null,
      canvasId: null,
      schoolColors: null,
      colors: [],
    };
  },

  async mounted () {
    this.schoolColors = this.$store.getters['elements/getSchoolColors'];
    this.svgText = await this.loadPatchSvg(this.canvasUrl);

    setTimeout(() => {
      this.initPatchCanvas();

      return true;
    }, 0);
  },

  methods: {
    async loadPatchSvg (fileUrl) {
      return svgApi.loadSvg(fileUrl).then((svgText) => {
        this.svgText = svgText;
        return svgText;
      });
    },

    initPatchCanvas () {
      this.canvasId = this.patchId;
      this.canvas = SVG(`${this.patchId}`).size(150, 150);
      this.canvas.id(this.canvasId);

      const groupWrapper = this.canvas.group().id(`${this.canvasId}--wrapper`);
      groupWrapper.svg(this.svgText);

      const svg = this.canvas.select('svg').get(0);
      svg.id('editing-patch');

      this.getColorsFromPatch();
      this.isCategoriesPending = false;
    },

    getColorsFromPatch () {
      const colors = this.getColorsByProperty('editing-patch', 'FILL', 'fill');
      const stroke = this.getColorsByProperty('editing-patch', 'STROKE', 'stroke');

      if (stroke.length !== 0) {
        colors.splice(2, 0, stroke);
      }
      const flattenColors = flattenDeep(colors);

      this.colors = flattenColors.map((color, index) => {
        const tag = (this.tagMaps && this.tagMaps[index]) ? this.tagMaps[index] : 'static';

        return { ...color, id: index, [`${color.layerId}`]: tag };
      }).sort((a, b) => (a.id > b.id ? 1 : -1));

      this.colors.forEach((item) => {
        if (item.order !== null) {
          this.colors.sort((a, b) => (a.order > b.order ? 1 : -1));
        }
      });

      if (this.schoolColors) {
        Object.keys(this.tagsMap).forEach((key) => {
          const fieldValue = this.tagsMap[key];

          if (fieldValue !== 'static') {
            this.changeSvgElementColor('editing-patch', { hex: this.schoolColors[fieldValue] }, key);
          }
        });
      }
    },
  }
};
</script>

<style>
  .svg-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
  }

  .text-svg-container > svg {
    width: fit-content;
  }

  svg {
    overflow: visible;
  }
</style>
